/* ===========================================================================
   Perguntas e respostas do produto — consome o node_avaliacoes.
   Contrato: README do node_avaliacoes. Resposta é { success, message, data }.

   A API só devolve pergunta JÁ respondida com resposta pública, e a resposta sai
   em nome da loja (campo `por`), nunca do atendente. Então aqui não existe estado
   de "aguardando resposta": o que chega, chega pronto.

   Mesmas decisões do bloco de avaliações: observer só depois do `load` (layout
   shift dispara observer sozinho na PDP) e todo texto da API passa por esc(),
   porque é conteúdo escrito por cliente.
   =========================================================================== */
(function () {
  'use strict';

  /* "Útil?" escondido enquanto a API não tiver rota de voto — ela entrega
     `util: {sim, nao}` mas não recebe. Religar aqui depois de criar a rota. */
  var MOSTRAR_UTIL = false;

  function svgCheck() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.3-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7z"/></svg>';
  }
  function svgPolegar(cima) {
    return cima
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 21h3V9H2v12zM22 10c0-1.1-.9-2-2-2h-6.3l.9-4.6V3.2c0-.4-.2-.8-.4-1L13 1 6.6 7.4c-.4.4-.6.9-.6 1.4V19c0 1.1.9 2 2 2h9c.8 0 1.5-.5 1.8-1.2l3-7c.1-.3.2-.5.2-.8v-2z"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 3h-3v12h3V3zM2 14c0 1.1.9 2 2 2h6.3l-.9 4.6v.2c0 .4.2.8.4 1l1.2 1.2 6.4-6.4c.4-.4.6-.9.6-1.4V5c0-1.1-.9-2-2-2H7c-.8 0-1.5.5-1.8 1.2l-3 7c-.1.3-.2.5-.2.8v2z"/></svg>';
  }

  function milhar(n) {
    /* as barras importam: /B(?=(d{3})+(?!d))/ procura a letra B e nunca casa */
    return String(Number(n) || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function esc(v) {
    if (v === null || v === undefined) return '';
    return String(v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* parse manual: new Date('2026-04-26') é UTC e no fuso -03 volta um dia */
  function dataBR(iso) {
    if (!iso) return '';
    var p = String(iso).slice(0, 10).split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : esc(iso);
  }

  function num(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function PHPerguntas(raiz) {
    if (!raiz || raiz.dataset.phqPronto === '1') return;
    raiz.dataset.phqPronto = '1';

    var ehLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
    var baseBruta = (ehLocal && raiz.dataset.apiDev) ? raiz.dataset.apiDev : raiz.dataset.api;

    var cfg = {
      base: (baseBruta || '').replace(/\/+$/, ''),
      loja: raiz.dataset.loja,
      produto: raiz.dataset.produto,
      porPagina: num(raiz.dataset.porPagina) || 10,
      sitekey: raiz.dataset.sitekey || ''
    };

    var el = {
      lista: raiz.querySelector('[data-phq-lista]'),
      vazio: raiz.querySelector('[data-phq-vazio]'),
      mais: raiz.querySelector('[data-phq-mais]'),
      erro: raiz.querySelector('[data-phq-erro]'),
      total: raiz.querySelector('[data-phq-total]'),
      contagem: raiz.querySelector('[data-phq-contagem]'),
      abrirForm: raiz.querySelector('[data-phq-abrir-form]'),
      modal: raiz.querySelector('[data-phq-modal]'),
      form: raiz.querySelector('[data-phq-form]'),
      formMsg: raiz.querySelector('[data-phq-form-msg]')
    };

    var estado = { pagina: 0, totalPaginas: 1, total: 0, carregados: 0, carregando: false };

    function url(caminho, params) {
      var u = cfg.base + '/v1/' + encodeURIComponent(cfg.loja) + '/produtos/' +
              encodeURIComponent(cfg.produto) + caminho;
      var q = [];
      Object.keys(params || {}).forEach(function (k) {
        var v = params[k];
        if (v !== null && v !== undefined && v !== '') {
          q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
      });
      return q.length ? u + '?' + q.join('&') : u;
    }

    function mostrarErro(msg) {
      if (!el.erro) return;
      el.erro.textContent = msg;
      el.erro.hidden = false;
    }

    function itemHtml(p) {
      var inicial = (String(p.autor || "?").trim().charAt(0) || "?").toUpperCase();
      var util = p.util || {};
      var r = p.resposta;

      /* `/\s+/`, não `/s+/`: com a barra faltando ele quebrava a string nas
         letras "s" e "Prohall Profissional" virava "PI" em vez de "PP". */
      var marcaLoja = r ? (String(r.por || "Loja").trim().split(/\s+/).map(function (x) {
        return x.charAt(0);
      }).join("").slice(0, 2).toUpperCase()) : "";

      var resposta = r
        ? '<div class="phq__resposta">' +
            '<div class="phq__resposta-topo">' +
              '<span class="phq__marca-loja" aria-hidden="true">' + esc(marcaLoja) + '</span>' +
              '<span class="phq__resposta-por">' + esc(r.por || "Resposta da loja") + '</span>' +
              '<span class="phq__oficial">' + svgCheck() + "Resposta oficial</span>" +
              '<span class="phq__quando">' + dataBR(r.data) + '</span>' +
            '</div>' +
            '<div class="phq__resposta-texto" data-phq-corte>' + esc(r.texto) + '</div>' +
            '<div class="phq__resposta-pe">' +
              '<button type="button" class="phq__ver" data-phq-ver hidden>Ver pergunta e resposta completas</button>' +
              (MOSTRAR_UTIL
                ? '<span class="pha__util">' +
                    '<span class="pha__util-rotulo">Útil?</span>' +
                    '<span class="pha__util-n">' + svgPolegar(true) + num(util.sim) + '</span>' +
                    '<span class="pha__util-n">' + svgPolegar(false) + num(util.nao) + '</span>' +
                  '</span>'
                : '') +
            '</div>' +
          '</div>'
        : "";

      return (
        '<li class="phq__item">' +
          '<div class="phq__pergunta">' +
            '<span class="phq__avatar" aria-hidden="true">' + esc(inicial) + '</span>' +
            '<div class="phq__pergunta-corpo">' +
              '<div class="phq__autor">' + esc(p.autor) + '</div>' +
              '<div class="phq__meta">Perguntou em ' + dataBR(p.data) + '</div>' +
              '<div class="phq__texto" data-phq-corte>' + esc(p.pergunta) + '</div>' +
            '</div>' +
          '</div>' +
          resposta +
        '</li>'
      );
    }

    /* O "ver completas" só aparece onde o texto realmente foi cortado. */
    function revelarBotoesDeCorte() {
      el.lista.querySelectorAll('[data-phq-ver]').forEach(function (b) {
        var item = b.closest('.phq__item');
        var cortados = item.querySelectorAll('[data-phq-corte]');
        var passou = Array.prototype.some.call(cortados, function (c) {
          return c.scrollHeight - c.clientHeight > 4;
        });
        b.hidden = !passou;
      });
    }
    function carregar(reiniciar) {
      if (estado.carregando) return;
      if (reiniciar) {
        estado.pagina = 0;
        estado.totalPaginas = 1;
        el.lista.innerHTML = '';
      }
      if (estado.pagina >= estado.totalPaginas) return;

      estado.carregando = true;
      if (el.mais) el.mais.disabled = true;

      var proxima = estado.pagina + 1;
      fetch(url('/perguntas', { pagina: proxima, por_pagina: cfg.porPagina }), {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (j) {
        if (!j || j.success !== true) throw new Error((j && j.message) || 'Resposta inválida');
        var d = j.data || {};
        var itens = d.itens || [];
        var pag = d.paginacao || {};

        estado.pagina = num(pag.pagina) || proxima;
        estado.totalPaginas = num(pag.total_paginas) || 1;
        estado.total = num(pag.total);
        estado.carregados += itens.length;

        el.lista.insertAdjacentHTML('beforeend', itens.map(itemHtml).join(''));
        revelarBotoesDeCorte();

        if (el.total && estado.pagina === 1) {
          el.total.textContent = estado.total
            ? 'Mostrando ' + milhar(estado.carregados) + ' de ' + milhar(estado.total) +
              (estado.total === 1 ? ' pergunta' : ' perguntas')
            : '';
        }
        if (el.contagem) {
          el.contagem.textContent = (estado.total && estado.carregados < estado.total)
            ? 'Mostrando ' + milhar(estado.carregados) + ' de ' + milhar(estado.total)
            : '';
        }
        if (el.total && estado.pagina > 1 && estado.total) {
          el.total.textContent = 'Mostrando ' + milhar(estado.carregados) + ' de ' +
            milhar(estado.total) + (estado.total === 1 ? ' pergunta' : ' perguntas');
        }
        if (el.vazio) el.vazio.hidden = !(estado.pagina === 1 && itens.length === 0);
        if (el.mais) el.mais.hidden = estado.pagina >= estado.totalPaginas;
      }).catch(function (e) {
        mostrarErro('Não foi possível carregar as perguntas agora. ' + e.message);
      }).then(function () {
        estado.carregando = false;
        if (el.mais) el.mais.disabled = false;
      });
    }

    if (el.mais) el.mais.addEventListener('click', function () { carregar(false); });

    /* expandir pergunta e resposta cortadas */
    el.lista.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-phq-ver]');
      if (!b) return;
      var item = b.closest('.phq__item');
      var aberto = item.classList.toggle('phq__item--aberto');
      b.textContent = aberto ? 'Ver menos' : 'Ver pergunta e resposta completas';
    });

    /* ----------------------------------------------------------- formulário */

    var turnstilePedido = false;
    function carregarTurnstile() {
      if (turnstilePedido || !cfg.sitekey) return;
      turnstilePedido = true;
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    }

    function abrirModal() {
      if (!el.modal) return;
      el.modal.hidden = false;
      document.body.classList.add('pha-modal-aberto');
      el.abrirForm.setAttribute('aria-expanded', 'true');
      carregarTurnstile();
      var primeiro = el.modal.querySelector('input, textarea, button');
      if (primeiro) setTimeout(function () { primeiro.focus(); }, 30);
    }

    function fecharModal() {
      if (!el.modal) return;
      el.modal.hidden = true;
      document.body.classList.remove('pha-modal-aberto');
      el.abrirForm.setAttribute('aria-expanded', 'false');
      el.abrirForm.focus();
    }

    if (el.abrirForm && el.modal) {
      el.abrirForm.addEventListener('click', abrirModal);
      el.modal.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-phq-fechar-modal]')) fecharModal();
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !el.modal.hidden) fecharModal();
      });
    }

    function msgForm(texto, ok) {
      if (!el.formMsg) return;
      el.formMsg.textContent = texto;
      el.formMsg.className = 'pha__msg ' + (ok ? 'pha__msg--ok' : 'pha__msg--erro');
    }

    if (el.form) {
      el.form.addEventListener('submit', function (ev) {
        ev.preventDefault();

        var campo = el.form.querySelector('[name="pergunta"]');
        var texto = (campo && campo.value || '').trim();
        if (texto.length < 5) return msgForm('Escreva sua pergunta com pelo menos 5 caracteres.', false);
        if (texto.length > 1000) return msgForm('Sua pergunta passou de 1000 caracteres.', false);

        var botao = el.form.querySelector('[type="submit"]');
        if (botao) botao.disabled = true;
        msgForm('Enviando…', true);

        /* urlencoded, não FormData: a rota de perguntas tem só os parsers
           express.json e express.urlencoded — multipart passaria direto por
           eles e o req.body chegaria vazio ("Informe seu nome" com o campo
           preenchido). Aqui não há arquivo, então urlencoded basta.
           O Content-Type correto o próprio navegador põe. */
        fetch(url('/perguntas'), {
          method: 'POST',
          body: new URLSearchParams(new FormData(el.form))
        })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (j && j.success) {
              msgForm(j.message || 'Pergunta recebida. Ela aparece aqui depois de respondida.', true);
              el.form.reset();
            } else {
              msgForm((j && j.message) || 'Não foi possível enviar sua pergunta.', false);
            }
            /* sem reset o segundo envio reusaria o token e seria recusado */
            if (window.turnstile) { try { window.turnstile.reset(); } catch (e) {} }
          })
          .catch(function () {
            msgForm('Não foi possível enviar agora. Tente de novo em instantes.', false);
          })
          .then(function () { if (botao) botao.disabled = false; });
      });
    }

    /* ---------------------------------------------------------- disparo */

    function armar() {
      if (!('IntersectionObserver' in window)) return carregar(true);
      var io = new IntersectionObserver(function (entradas) {
        if (entradas.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          carregar(true);
        }
      }, { rootMargin: '400px 0px' });
      io.observe(raiz);
    }

    if (document.readyState === 'complete') armar();
    else window.addEventListener('load', armar, { once: true });
  }

  function varrer(escopo) {
    (escopo || document).querySelectorAll('[data-phq]').forEach(PHPerguntas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { varrer(); });
  } else {
    varrer();
  }

  document.addEventListener('shopify:section:load', function (ev) { varrer(ev.target); });
})();
